export default __webpack_public_path__ + "static/media/arrow-long-left.ffd1d6de.svg";